import { setCountAction } from "./_common.js";

const main = () => {
    if (document.querySelector('#page-search-area') === null) return;
    console.log('search area page');
    setCountAction();
}

export default main;
